import { useT } from "../lib/LangContext";

export const TrendingTopics = ({ data }) => {
  const { t } = useT();
  if (!data) return null;
  const topics = data.topics || [];
  if (!topics.length) return null;

  return (
    <div className="card-soft p-5" data-testid="trending-topics">
      <h3 className="text-[11px] uppercase tracking-wider text-[#6B7280] mb-4">
        {t("trending_topics")}
      </h3>
      <div className="flex flex-wrap gap-2">
        {topics.map((topic) => (
          <span
            key={topic}
            className="px-3 py-1 rounded-full text-xs bg-[#0AADA0]/10 text-[#0AADA0] hover:bg-[#0AADA0]/20 transition-colors cursor-default"
            data-testid={`trending-topic-${topic.toLowerCase()}`}
          >
            #{topic}
          </span>
        ))}
      </div>
    </div>
  );
};
